import { useEffect, useRef, useState } from 'react';


export const useCameraTrack = (device, isEnabled = true) => {
  const videoTrackRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deviceId, setDeviceId] = useState(null);


  useEffect(() => {
    setDeviceId(device?.deviceId ? device.deviceId : null);
  }, [device, isEnabled]);

  useEffect(() => {
    let isMounted = true;

    const createVideoTrack = async () => {
      try {
        setLoading(true);
        setError(null);

        // Cleanup previous track if it exists
        if (videoTrackRef.current) {
          videoTrackRef.current.stop();
          videoTrackRef.current = null;
        }

        // Check if camera is disabled or no device selected
        if (!isEnabled || !deviceId) {
          setLoading(false);
          return;
        }
        console.log("deviceId", deviceId);

        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1280 },
            height: { ideal: 720 },
            // Don't specify deviceId to get user's default camera (avoid overconstraint)
            ...(deviceId && deviceId !== 'default' && { deviceId: { exact: deviceId } })
          }
        });

        if (!isMounted) {
          // Component unmounted during async operation
          stream.getTracks().forEach(track => track.stop());
          return;
        }

        const videoTrack = stream.getVideoTracks()[0];
        videoTrackRef.current = videoTrack;
        setLoading(false);
        
      } catch (err) {
        if (!isMounted) return;
        
        setLoading(false);
        
        // Categorize errors for better handling
        if (err.name === 'NotAllowedError') {
          setError({ type: 'permission', message: 'Camera permission denied' });
        } else if (err.name === 'NotFoundError') {
          setError({ type: 'not-found', message: 'Camera device not found' });
        } else if (err.name === 'NotReadableError') {
          setError({ type: 'in-use', message: 'Camera is already in use' });
        } else {
          setError({ type: 'generic', message: err.message || 'Failed to access camera' });
        }
        
        console.error('Camera track error:', err);
      }
    };

    createVideoTrack();

    // Cleanup function
    return () => {
      isMounted = false;
      if (videoTrackRef.current) {
        videoTrackRef.current.stop();
        videoTrackRef.current = null;
      }
      setLoading(false);
    };
  }, [deviceId, isEnabled]); // Stable dependencies

  return {
    track: videoTrackRef.current,
    loading,
    error
  };
};
